"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));
var _Visibility = _interopRequireDefault(require("@material-ui/icons/Visibility"));
var _VisibilityOff = _interopRequireDefault(require("@material-ui/icons/VisibilityOff"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Componente para entrada de texto
 */
const PasswordInput = _ref => {
  let {
    color,
    disabled,
    helperText,
    error,
    fullWidth,
    label,
    id,
    name,
    onChange,
    required,
    value
  } = _ref;
  const [values, setValues] = _react.default.useState({
    showPassword: false
  });
  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword
    });
  };
  const handleMouseDownPassword = event => {
    event.preventDefault();
  };
  return /*#__PURE__*/_react.default.createElement(_core.TextField, {
    color: color,
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    helperText: helperText,
    id: id,
    InputProps: {
      endAdornment: /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
        position: "end"
      }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
        "aria-label": "toggle password visibility",
        onClick: handleClickShowPassword,
        onMouseDown: handleMouseDownPassword,
        edge: "end"
      }, values.showPassword ? /*#__PURE__*/_react.default.createElement(_Visibility.default, null) : /*#__PURE__*/_react.default.createElement(_VisibilityOff.default, null)))
    },
    label: label,
    name: name,
    onChange: onChange,
    required: required,
    type: values.showPassword ? 'text' : 'password',
    value: value,
    variant: "outlined"
  });
};
exports.PasswordInput = PasswordInput;
PasswordInput.propTypes = {
  /**
   * Cor do campo
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']).isRequired,
  /**
   * Se `true` o campo é desabilitado
   */
  disabled: _propTypes.default.bool,
  /**
   * Se `true` o campo fica no estado de erro
   */
  error: _propTypes.default.bool,
  /**
   * Propriedade para deixar o campo com largura máxima
   */
  fullWidth: _propTypes.default.bool,
  /**
   * Texto de auxílio de preechimento do campo ou mensagem de erro
   */
  helperText: _propTypes.default.string,
  /**
   * Atributo `id` do componente
   */
  id: _propTypes.default.string,
  /**
   * Label do componente
   */
  label: _propTypes.default.string,
  /**
   * Atributo `name` do input
   */
  name: _propTypes.default.string,
  /**
   * Função executada quando valor é mudado
   */
  onChange: _propTypes.default.func,
  /**
   * Se `true` o campo se mostra como obrigatório
   */
  required: _propTypes.default.bool,
  /**
   * Valor digitado no campo
   */
  value: _propTypes.default.string
};
PasswordInput.defaultProps = {
  error: false,
  disabled: false,
  fullWidth: false,
  helperText: null,
  id: null,
  label: null,
  name: null,
  onChange: null,
  required: false,
  value: null
};